import React from "react";
import faqs from "../../assets/data/faqs.json";
import Accordion from "react-bootstrap/Accordion";

const FaqSection = () => {
  return (
    <section className="faq-section">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-10 mx-auto">
            <div className="section-heading">
              <h2>Frequently Asked Questions</h2>
            </div>
            <Accordion defaultActiveKey="0">
              {faqs.homePage.map((faq, index) => {
                return (
                  <Accordion.Item
                    key={index}
                    eventKey={`${index}`}
                    className="faq-card"
                  >
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body>
                      <div className="faq-info">{faq.answer}</div>
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
